import { render, staticRenderFns } from "./tenderingfrm2.vue?vue&type=template&id=08e6f6d4"
import script from "./tenderingfrm2.vue?vue&type=script&lang=js"
export * from "./tenderingfrm2.vue?vue&type=script&lang=js"
import style0 from "./tenderingfrm2.vue?vue&type=style&index=0&id=08e6f6d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports